import React from 'react';
import Footer from '@kmdpartners/ui-kit/src/CN_Design_System/blocks/Footer';
import { DEFAULTS } from '@kmdpartners/ui-kit/src/CN_Design_System/blocks/Footer/constants';
// @ts-ignore
import discloseDoc from '../../../../assets/images/account-opening-disclosure.pdf';
const FEB_PRIVACY_POLICY_URL = 'https://firstelectronic.bank/privacy-notice/';
const CCB_PRIVACY_POLICY_URL = '/docs/quill-bank-privacy-policy.pdf';
const CC_CONNECT_CA_PRIVACY_POLICY_URL = '/docs/quill-bank-ca-privacy-policy.pdf';
const BARR_PRIVACY_POLICY_URL = '/docs/barr-privacy-policy.pdf';
const FEB_LINK_INDEX = 9;
// CCB and CC Connect CA privacy policies are injected directly beneath FEB Privacy Policy,
// which shifts the existing Barr and Account Opening Disclosure links down by two.
const CCB_LINK_INDEX = 10;
const CC_CONNECT_CA_LINK_INDEX = 11;
const BARR_LINK_INDEX = 12;
const ACCOUNT_OPENING_DISCLOSURE_INDEX = 13;
const CCB_PRIVACY_POLICY_LINK = {
    label: 'Quill Bank Privacy Policy',
    target: '_blank',
    href: CCB_PRIVACY_POLICY_URL
};
const CC_CONNECT_CA_PRIVACY_POLICY_LINK = {
    label: 'Quill Bank CA Privacy Policy',
    target: '_blank',
    href: CC_CONNECT_CA_PRIVACY_POLICY_URL
};
const BARR_PRIVACY_POLICY_LINK = {
    label: 'Barr Privacy Policy',
    target: '_blank',
    href: BARR_PRIVACY_POLICY_URL
};
const FooterBlock = ({ footerCustomConfig, showExtoleReferFriend, pathname }) => {
    var _a;
    const customLinks = [...((_a = DEFAULTS.links) !== null && _a !== void 0 ? _a : [])];
    customLinks.splice(CCB_LINK_INDEX, 0, CCB_PRIVACY_POLICY_LINK, CC_CONNECT_CA_PRIVACY_POLICY_LINK, BARR_PRIVACY_POLICY_LINK);
    const _linksModifier = (link, index) => {
        if (index === FEB_LINK_INDEX) {
            return Object.assign(Object.assign({}, link), { target: '_self', href: FEB_PRIVACY_POLICY_URL });
        }
        if (index === CCB_LINK_INDEX) {
            return Object.assign(Object.assign({}, link), { target: '_blank', href: CCB_PRIVACY_POLICY_URL });
        }
        if (index === CC_CONNECT_CA_LINK_INDEX) {
            return Object.assign(Object.assign({}, link), { target: '_blank', href: CC_CONNECT_CA_PRIVACY_POLICY_URL });
        }
        if (index === BARR_LINK_INDEX) {
            return Object.assign(Object.assign({}, link), { target: '_blank', href: BARR_PRIVACY_POLICY_URL });
        }
        if (index === ACCOUNT_OPENING_DISCLOSURE_INDEX) {
            return Object.assign(Object.assign({}, link), { target: '_self', href: discloseDoc });
        }
        return Object.assign(Object.assign({}, link), { target: '_self' });
    };
    const isIdentityPath = pathname === '/registration/identity';
    const disclosureItems = (footerCustomConfig === null || footerCustomConfig === void 0 ? void 0 : footerCustomConfig.disclosure) || DEFAULTS.disclosure;
    const filteredDisclosure = disclosureItems.filter((_, index) => isIdentityPath || ![1, 2, 3, 11].includes(index));
    const footerData = Object.assign(Object.assign({}, DEFAULTS), { title: (footerCustomConfig === null || footerCustomConfig === void 0 ? void 0 : footerCustomConfig.title) || DEFAULTS.title, mainText: (footerCustomConfig === null || footerCustomConfig === void 0 ? void 0 : footerCustomConfig.mainText) || DEFAULTS.mainText, disclosure: filteredDisclosure, 
        // modifying some links because of
        // versioning system on the RubyOnRails backend
        links: customLinks.map(_linksModifier) });
    return React.createElement(Footer, { dataToAppear: footerData, withReferFriend: showExtoleReferFriend });
};
export default FooterBlock;
